<template>
    <div class="ServiceItem" v-html="serviceData">

    </div>
</template>

<script>
import { getServiceItems } from "@/api/login/index"
export default {
    name: 'ServiceItem',
    data() {
        return {
            // data properties
            serviceData: ''
        }
    },
    mounted() {

        this.getServiceItems();
    },
    methods: {
        // methods
        async getServiceItems() {
            let { data: res } = await getServiceItems();
            console.log(res);
            this.serviceData = res
            if (!res) return

        }
    }
}
</script>

<style lang="scss" scoped>
.ServiceItem {
    /* styles */
}
</style>